import Rails from '@rails/ujs';
import CableController from './cable_controller';

export default class extends CableController {
  static targets = [
    'input',
    'message',
    'messages',
    'messageTemplate',
    'myMessageTemplate',
    'dateTemplate',
    'date',
  ];

  newDate() {
    return this.dateTemplateTarget.content.children[0].cloneNode(true);
  }

  newMessage(data) {
    const { user_uuid: userUuid } = data;
    if (this.userUuid === userUuid) {
      return this.myMessageTemplateTarget.content.children[0].cloneNode(true);
    }

    return this.messageTemplateTarget.content.children[0].cloneNode(true);
  }

  get userUuid() {
    return this.data.get('user-uuid');
  }

  send() {
    this.inputTarget.value = '';
  }

  clearInput() {
    this.inputTarget.value = '';
  }

  targetForDate(date) {
    return this.dateTargets.find((element) => element.textContent.trim() === date);
  }

  received(data) {
    if (data.date && !this.targetForDate(data.date)) {
      const date = this.newDate();
      date.querySelector('.my-message-date').textContent = data.date;
      this.messagesTarget.appendChild(date);
    }
    const message = this.newMessage(data);
    message.querySelector('.my-message-text').textContent = data.text;
    message.querySelector('.my-message-display-name').textContent = data.display_name;
    message.dataset.date = data.date;
    this.messagesTarget.appendChild(message);
    Rails.fire(this.messagesTarget, 'scrollRequest');
  }

  get channel() {
    return super.channel || 'PropertyContractChannel';
  }
}
